'use strict';

exports.__esModule = true;
exports.connect = exports.call = undefined;

var _call = require('./generators/call');

var _call2 = _interopRequireDefault(_call);

var _connect = require('./connect');

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.call = _call2.default;
exports.connect = _connect2.default;